// Google Analytics 4 Configuration for Maggie's Miracle Website

// Google Analytics 4 Measurement ID for butdidyoudie.life
export const GA_TRACKING_ID = 'G-RDP8HGQCQB';

// Access gtag function from window object (loaded via script tag)
const gtag = (...args) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
};

// Initialize Google Analytics
export const initGA = () => {
  // Only initialize in production or when tracking ID is set
  if (GA_TRACKING_ID !== 'G-XXXXXXXXXX' && typeof window !== 'undefined') {
    gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
      send_page_view: true,
    });
  }
};

// Track page views
export const trackPageView = (path, title) => {
  if (GA_TRACKING_ID !== 'G-XXXXXXXXXX' && typeof window !== 'undefined') {
    gtag('event', 'page_view', {
      page_title: title || document.title,
      page_location: window.location.href,
      page_path: path,
    });
  }
};

// Track button clicks and general interactions
export const trackEvent = (action, category, label, value) => {
  if (GA_TRACKING_ID !== 'G-XXXXXXXXXX' && typeof window !== 'undefined') {
    gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Specific tracking functions for Maggie's Miracle Website

// Track navigation clicks
export const trackNavigation = (pageName) => {
  trackEvent('click', 'Navigation', `Navigate to ${pageName}`);
};

// Track video interactions
export const trackVideoEvent = (action, videoTitle) => {
  trackEvent(action, 'Video', videoTitle);
};

// Track download events
export const trackDownload = (fileName, fileType) => {
  trackEvent('download', 'File Download', `${fileName} (${fileType})`);
};

// Track external link clicks (heart health resources, etc.)
export const trackExternalLink = (url, linkText) => {
  trackEvent('click', 'External Link', `${linkText} - ${url}`);
};

// Track contact interactions
export const trackContact = (method) => {
  trackEvent('contact', 'Contact Interaction', method);
};

// Track message submissions
export const trackMessageSubmission = (type = 'community_message') => {
  trackEvent('submit', 'Form Submission', type);
};

// Track photo gallery interactions
export const trackPhotoView = (photoName) => {
  trackEvent('view', 'Photo Gallery', photoName);
};

// Track timeline interactions
export const trackTimelineView = (event) => {
  trackEvent('view', 'Timeline', event);
};

// Track calendar interactions
export const trackCalendarView = (date) => {
  trackEvent('view', 'Calendar', date);
};

// Track spiritual content engagement
export const trackSpiritualContent = (contentType, title) => {
  trackEvent('engage', 'Spiritual Content', `${contentType}: ${title}`);
};

// Track heart health resource engagement
export const trackHeartHealthResource = (resourceName) => {
  trackEvent('click', 'Heart Health Resource', resourceName);
};

// Track testimonial engagement
export const trackTestimonial = (testimonialType, person) => {
  trackEvent('engage', 'Testimonial', `${testimonialType} - ${person}`);
};

// Helper function to check if analytics is enabled
export const isAnalyticsEnabled = () => {
  return GA_TRACKING_ID !== 'G-XXXXXXXXXX' && typeof window !== 'undefined';
};

// Debug function to log events in development
export const debugEvent = (eventName, parameters) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('📊 Analytics Event:', eventName, parameters);
  }
};
